import { render, staticRenderFns } from "./MMenu.vue?vue&type=template&id=4ab85b20"
import script from "./MMenu.vue?vue&type=script&lang=js"
export * from "./MMenu.vue?vue&type=script&lang=js"
import style0 from "./MMenu.vue?vue&type=style&index=0&id=4ab85b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports